export default "__VITE_ASSET__6a3c8908__"